import { Component, OnInit } from '@angular/core';
import { AuthService, Auth } from '../auth/auth.service';

@Component({
  selector: 'legacy-login',
  templateUrl: './legacy-login.component.html',
})
export class LegacyLoginComponent implements OnInit {

  constructor(public auth: AuthService) { }

  loading: boolean = false;
  error: string = '';
  formUser: string;
  formPasswd: string;

  ngOnInit() {
    this.auth.onAuthChanged
      .subscribe((authState: Auth) => {
        this.loading = false;
        this.error = authState ? authState.message : '';
      });
  }

  onLogin() {
    if (!this.formUser || !this.formPasswd) { return; }
    this.error = '';
    this.loading = true;
    this.auth.login(this.formUser, this.formPasswd);
  }

  onLogout() {
    this.auth.logout();
  }
}
